import comp from "./SinglePageScrollController";
export default comp;
